import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { FUNCTIONS_END_POINT_URL } from '../config/firebase-config';
import { AngularFireDatabase } from 'angularfire2/database';
import { isNil } from 'lodash';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SupplierProvider {

  constructor( public http: HttpClient, private db: AngularFireDatabase ) { }

  public getAverage( id: string, startDate: string, endDate: string ): Promise<seafrozen.ISupplierAveragesResponse> {

    const params = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);

    const response = this.http.get<seafrozen.ISupplierAveragesResponse>(`${FUNCTIONS_END_POINT_URL}/suppliers/${id}/average`, { params } ).toPromise();

    return response;
  }


  /** Gets a suppliers name by their id */
  public getNameById( id: string ): Observable<string> {
    const supplier$ = this.db.object('suppliers/' + id)
      .filter(supplier => !isNil(supplier))
      .map( (supplier: seafrozen.ISupplier) => supplier.name);

    return supplier$;
  }

}



// WEBPACK FOOTER //
// ./src/providers/supplier.service.ts